import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'listo-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent {
  @Input() open: boolean;
  @Output() close = new EventEmitter();
}
